module.exports = __webpack_public_path__ + "assets/icons/ic_move_device_24px.svg";